/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import useT, {
    UseTranslationOptions,
} from "../../../Basis/Internationalisierung/Hooks/useTranslation";
import i18n from "../../../Basis/Internationalisierung/i18n";

export const useTranslation = (options?: UseTranslationOptions) => useT("i18nBenachrichtigungen", options);
export const fixedT = i18n.getFixedT(null, "i18nBenachrichtigungen");

export const translationKeys = {
    appNotifications: {
        notifications: "appNotifications.notifications",
        markAllRead: "appNotifications.markAllRead",
        benachrichtigungErledigt: "appNotifications.benachrichtigungErledigt",
        benachrichtigungErledigtText: "appNotifications.benachrichtigungErledigtText"
    }
};
